import { Redirect, useLocation } from 'react-router-dom'

export const AuthRedirect = () => {
  const location = useLocation()

  const queryParams = location.search

  return <Redirect to={`/signin${queryParams}`} />
}
